/** Opens a PDF returned as `{ filename, contentType, data: base64 }` (same shape as purchase-order print). */
export function openPdfFromBase64Payload(payload: {
  filename: string;
  contentType: string;
  data: string;
}): void {
  const byteCharacters = atob(payload.data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: payload.contentType });
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank', 'noopener,noreferrer');
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
